import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./Create.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

class Create extends Component {
  state = {
    isLoading: false,
    password: "",
    formId: 1,
  };

  setPassword = (password) => {
    this.setState({ password: password });
  };

  render() {
    const initialValues = {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      role: "",
      password: "",
      status: "",
    };

    const validationSchema = Yup.object({
      firstName: Yup.string()
        .required("First Name is required")
        .trim()
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
      lastName: Yup.string()
        .required("Last Name is required")
        .trim()
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
      phone: Yup.string()
        .required("Phone is required")
        .matches(/^[0-9]+$/, "Not a Valid Phone Number"),
      email: Yup.string()
        .required("Email is required")
        .matches(/^[a-zA-Z0-9.@_ ]+$/, "Invalid Email ID")
        .test("regex", "Invalid Email ID", (val) => {
          const regExpEmail = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i);
          return regExpEmail.test(val);
        }),
      role: Yup.string().required("Role is required"),
      password: Yup.string()
        .required("Password is required")
        .max(14, "Password must contain only 14 characters")
        .min(7, "Password must be at least 7 characters"),
      status: Yup.string().required("Status is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = {
        first_name: values.firstName,
        last_name: values.lastName,
        phone: values.phone,
        email: values.email,
        password: values.password,
        role: values.role,
        status: values.status,
      };

      axios
        .post("/admins", formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    const statusOptions = [
      { value: "0", label: "Disabled" },
      { value: "1", label: "Enabled" },
    ];

    const roleOptions = [
      { value: "1", label: "Superadmin" },
      { value: "2", label: "Admin" },
      { value: "3", label: "General" },
    ];

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>New | Admins | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Admins</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/admins">Admins</Link>
              </li>
              <li>New</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Add Admin</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              <Formik
                key={this.state.formId}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                render={({ setFieldValue }) => {
                  return (
                    <Form>
                      <div className={["FormBody", styles.FormBody].join(" ")}>
                        <FormikControl
                          control="input"
                          type="text"
                          label="First Name *"
                          name="firstName"
                          maxLength="30"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Last Name *"
                          name="lastName"
                          maxLength="30"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Phone *"
                          name="phone"
                          maxLength="10"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Email *"
                          name="email"
                          maxLength="150"
                          autocomplete="new-password"
                        />

                        <FormikControl
                          control="select"
                          label="Role *"
                          name="role"
                          options={roleOptions}
                          setFieldValue={setFieldValue}
                        />

                        <FormikControl
                          control="passwordStrength"
                          type="password"
                          label="Password *"
                          name="password"
                          autocomplete="new-password"
                          setPassword={this.setPassword}
                          password={this.state.password}
                        />

                        <FormikControl
                          control="select"
                          label="Status *"
                          name="status"
                          options={statusOptions}
                          setFieldValue={setFieldValue}
                        />
                      </div>

                      <div
                        className={["FormActions", styles.FormActions].join(
                          " "
                        )}
                      >
                        <Button
                          btnType="Primary"
                          type="Submit"
                          width="W100"
                          isLoading={this.state.isLoading}
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              />
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Create;
